






































import ScrollLine, { ScrollLineItem } from '@/components/ScrollLine';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { MapProps, MapSettings } from './types';

@Component({
    components: {
        ScrollLine,

        ScrollLineItem,

        YandexMap: () =>
            import(
                /* webpackChunkName: "YandexMap" */
                /* webpackMode: "lazy" */ 'vue-yandex-maps'
            ).then(({ yandexMap }) => yandexMap),
        YmapMarker: () =>
            import(
                /* webpackChunkName: "YandexMap" */
                /* webpackMode: "lazy" */ 'vue-yandex-maps'
            ).then(({ ymapMarker }) => ymapMarker),
    },
})
export default class Map extends Vue implements MapProps {
    /**
     *
     */
    @Prop()
    public readonly settings!: MapSettings;
    /**
     *
     */
    public markersGroupsSelected: Record<string, true> = {};
    /**
     *
     */
    public get mapSettings() {
        return this.settings?.map || {};
    }
    /**
     *
     */
    public get markers() {
        return this.settings?.markers || [];
    }
    /**
     *
     */
    public get markersGroups() {
        return this.settings?.markersGroups || [];
    }
    /**
     *
     */
    public get filteredMarkerGroups() {
        return this.markersGroups.filter((group) =>
            this.markersGroupsSelected?.hasOwnProperty(group.groupId)
        );
    }
    /**
     *
     */
    public onMarkerGroupClick(groupId: string) {
        if (this.markersGroupsSelected[groupId]) {
            this.$delete(this.$data.markersGroupsSelected, groupId);
        } else {
            this.$set(this.$data.markersGroupsSelected, groupId, true);
        }
    }
    /**
     *
     */
    public created() {
        if (this.settings.markersGroupsSelected) {
            this.markersGroupsSelected = this.settings.markersGroupsSelected.reduce(
                (prev, curr) => ({ ...prev, [curr]: true as const }),
                {} as Record<string, true>
            );
        }
    }
}
